import { render, staticRenderFns } from "./MaterialInitializationLabelPrinting.vue?vue&type=template&id=37202049&scoped=true&"
import script from "./MaterialInitializationLabelPrinting.vue?vue&type=script&lang=js&"
export * from "./MaterialInitializationLabelPrinting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37202049",
  null
  
)

export default component.exports